import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core';
import PageHeader from './PageHeader';

const styles = theme => ({
    root: {
        width: 760,
        margin: `${theme.spacing(8)}px auto`,
    },
});

const PageContainer = ({ title, subtitle, classes, className, children }) => {
    return (
        <div className={classNames(classes.root, className)}>
            <PageHeader title={title} subtitle={subtitle} outside />
            {children}
        </div>
    );
};

PageContainer.propTypes = {
    title: PropTypes.string,
    subtitle: PropTypes.string,
    classes: PropTypes.object.isRequired,
    className: PropTypes.string,
    children: PropTypes.node.isRequired,
};

export default withStyles(styles)(PageContainer);
